import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { portalCfg } from "../config";
import TermConditionController from "../pages/term-condition/TermConditionController";
import { getAppConfig } from "../utils/commons";
import CustomDivider from './CustomDivider';
import { FacebookIcon, InstagramIcon, TwitterIcon } from "./CustomIcons";

const footerImage = portalCfg.publicPath+ "/images/word_map.png"

const useStyles = makeStyles((theme) => ({
    footer: {
        backgroundImage: 'url(' + footerImage + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 50%',
        background: '#f4f4f4',
        padding: theme.spacing(2),
    },
    footer_content: {
        padding: theme.spacing(3, 0),
        lineHeight: 2.5,
    },
    term: {
        cursor: 'pointer',
    },
    title_strong: {
        color: theme.palette.primary.main,
    },
    icon_content: {
        background: theme.palette.primary.main,
        width: 32,
        height: 32,
        borderRadius: 32,
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        margin: theme.spacing(0, 1)
    },
}));

export default function CustomFooter(props){
    const classes = useStyles();
    const {t} = useTranslation();
    const [showTerm, setShowTerm] = useState(false);

    const onShowTerm = () => {
        const appConfig = getAppConfig();
        const content = appConfig && appConfig.about_details && appConfig.about_details.terms_conditions && appConfig.about_details.terms_conditions.content ? appConfig.about_details.terms_conditions.content : null;
        const urlTerm = appConfig && appConfig.about_details && appConfig.about_details.terms_conditions && appConfig.about_details.terms_conditions.url ? appConfig.about_details.terms_conditions.url : null;

        if(urlTerm){
            let tagA = document.createElement('a');
            tagA.setAttribute('targe', '_blank');
            tagA.setAttribute('id', 'term_condition_link');
            tagA.setAttribute('href', urlTerm);
            // tagA.style.display = 'none';
            document.body.append(tagA);
            document.getElementById('term_condition_link').click();
        }else{
            setShowTerm(true);
        }
    }

    return (
        <>
            <Grid xs={12} marginTop={5} item container justifyContent="center">
                <Grid item xs={12} container justifyContent="center" className={classes.footer}>
                    <CustomDivider />
                    <Grid xs={12} item marginTop={2} container justifyContent="center">
                        <Typography variant='h1' color='primary'>{t('contact_us')}</Typography>
                    </Grid>
                    <Grid xs={12} item marginTop={0.5} container justifyContent="center">
                        <Typography variant='p'>{t('contact_us_desc')}</Typography>
                    </Grid>
                    <Grid item xs={12} className={classes.footer_content}>
                        <Grid xs={12} item container justifyContent="center">
                            <Typography variant='subtitle2'>{t('customer_support')}: {t('email_us_at')} <strong className={classes.title_strong}>help@fly.cool</strong></Typography>
                        </Grid>
                        <Grid xs={12} item container justifyContent="center">
                            <Typography variant="p">Fly.cool (LAB4IR), Wrigley Field Building, The Campus Business Park, 57 Sloane Street, Bryanston, 2021, Gauteng, South Africa</Typography>
                        </Grid>
                        <Grid xs={12} item container justifyContent="center">
                            <Typography variant="subtitle1" color='primary' className={classes.term} onClick={() => onShowTerm()}>{t('term_condition')}</Typography>
                        </Grid>
                        <Grid xs={12} item container justifyContent="center">
                            <Typography >{t('or_follow_us')}</Typography>
                        </Grid>
                        <Grid xs={12} item marginTop={2} container justifyContent="center">
                            <Grid item className={classes.icon_content}>
                                <TwitterIcon />
                            </Grid>
                            <Grid item className={classes.icon_content}>
                                <FacebookIcon />
                            </Grid>
                            <Grid item className={classes.icon_content}>
                                <InstagramIcon />
                            </Grid>
                        </Grid>
                        <Grid xs={12} item container justifyContent="center" alignItems={'center'}>
                            <img src={portalCfg.publicPath + '/images/visamaster.png'} className={classes.image_footer}></img>
                            <img src={portalCfg.publicPath + '/images/paygate.png'} className={classes.image_footer}></img>                            
                        </Grid>
                        <Grid xs={12} item container justifyContent="center">
                            <Typography variant='caption'>© 2021 Fly.cool</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {showTerm && <TermConditionController 
                open={showTerm}
                onClose={() => setShowTerm(false)}
            />}
        </>
    );
}